import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=793b2cd8&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=793b2cd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793b2cd8",
  null
  
)

export default component.exports